import { webdav } from '../deps.js'
import * as tokens from '../auth/tokens.js'

async function createAcequiaClient() {
    let client = webdav.createClient('/', {
        authType: webdav.AuthType.Token,
        token: {
            token_type: 'Bearer',
            access_token: await tokens.createDeviceToken({}),
        },
    })

    return client
}

export { webdav, createAcequiaClient }
